import { render, staticRenderFns } from "./HeaderLegal.vue?vue&type=template&id=d1bcd864"
import script from "./HeaderLegal.vue?vue&type=script&lang=js"
export * from "./HeaderLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports